<template>
	<div class="parser">
		<div class="headerBox">
			<!--抄读方式列表-->
			<div style="width:84%;">
				<el-radio-group v-model="category_id" @change="tabClick">
					<el-radio-button :label="item.id" :key="item.id" v-for="(item) in categoryList">{{item.name}}</el-radio-button>
				</el-radio-group>
			</div>
			<el-button type="primary" plain class="addButtonClass2" @click="exportClick()">导出抄读</el-button>
			<el-button type="primary" plain class="addButtonClass" @click="addClick()">新建抄读方式</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" v-loading="loading">
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 4px;">{{(pageIndex-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				<el-table-column prop="name" label="抄读名称" min-width="1%">
				</el-table-column>
				<!--<el-table-column prop="" label="抄读方式" min-width="1%">
				</el-table-column>-->
				<el-table-column prop="remark" label="备注" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="操作" min-width="1%">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="lockClick(scope.row.id,'1')" v-if="scope.row.lock_status==0">锁定</a>
						<a class="editClass" @click.prevent="lockClick(scope.row.id,'0')" v-if="scope.row.lock_status==1">解锁</a>
						<a class="editClass" @click.prevent="detailClick(scope.row.id,scope.row)">查看</a>
						<a class="editClass" @click.prevent="editClick(scope.row.id,scope.row)" v-if="scope.row.lock_status==0">编辑</a>
						<a class="editClass" @click.prevent="deleteClick(scope.row.id)" v-if="scope.row.lock_status==0">删除</a>
						<a class="editClass" @click.prevent="copyClick(scope.row.id,scope.row.name)">复制</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20" :current-page.sync="pageIndex">
			</el-pagination>
		</div>
		<!--弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form>
				<el-form-item label="抄读名称" label-width="20%">
					<el-input type="text" v-model="nameValue" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注" label-width="20%">
					<el-input type="text" v-model="remark" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="所属分类" label-width="20%" style="position: relative;">
					<el-select v-model="categoryData" multiple @change="handleWeekChange" style="width: 100%;">
						<el-option v-for="(item, index) in categoryList" :key="item.id" :value="item.id" :label="item.name">
							<el-checkbox v-model="item.isCheck" @change="handleCheckBoxWeekChange"></el-checkbox>
							<span style="margin-left: 8px">{{item.name}}</span>
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="cancleClick" class="cancle">取消</el-button>
			</div>
		</el-dialog>
		<!--复制弹窗-->
		<div class="copyDialog">
			<el-dialog :title="title" :visible.sync="dialogFormVisible2" :width="dialogWidth" :close-on-click-modal="false">
				<div style="margin-bottom: 6px;">新的抄读名称</div>
				<el-input type="text" v-model="newName" autocomplete="off"></el-input>
				<div slot="footer" class="dialog-footer">
					<el-button @click="copySave()" class="confrim" type="primary">确认复制</el-button>
					<el-button @click="dialogFormVisible2=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
		</div>

	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			if(this.$route.query.fI) {
				this.pageIndex = this.$route.query.fI
			}
			if(typeof(this.pageIndex) != 'number') {
				this.pageIndex = Number(this.pageIndex)
			}
			this.getList();
			this.getCategoryList();
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
				} else {
					this.dialogWidth = "30%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
			} else {
				this.dialogWidth = "30%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false, //加载状态
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [], //列表
				dialogFormVisible: false,
				dialogFormVisible2: false,
				title: '', //弹窗标题
				/*表单*/
				nameValue: '', //名称
				remark: '', //备注
				dialogWidth: '30%', //dialog的宽度
				editId: null, //编辑的id
				lock_status: '', //锁定
				oldId: '', //要复制的抄读ID
				newName: '', //复制后的抄读名称
				category_id: '', //分类id
				categoryList: [], //分类列表
				categoryData: [] //所属非标类列表

			}
		},
		methods: {
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//分类列表
			getCategoryList() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.categoryList = res.data
						this.categoryList.forEach(item => {
							item.isCheck = false
						})
						if(window.sessionStorage.getItem('category_idcopy')) {
							this.category_id = window.sessionStorage.getItem('category_idcopy')
						} else {
							this.category_id = this.categoryList[0].id
						}
						this.getList();
					} else {
						this.categoryList = []
						this.category_id = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//tab的点击
			tabClick(val) {
				this.pageIndex=1
				this.category_id = val;
				window.sessionStorage.setItem('category_idcopy', this.category_id)
				this.getList();
			},
			//加载的动画
			openFullScreen() {
				this.loadingAdd = this.$loading({
					lock: true,
					text: '',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0)'
				});
			},
			//导出
			exportClick() {
				let config = headers.headers('exportAll')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				this.openFullScreen();
				var params = {
					path: '/mnt/xvdb/html/zkepA/storage/excel/',
				}
				//console.log(params)
				axios.get(this.http + '/zkep2/parser/exportAll', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.openFullScreen();
					//console.log(res)
					if(res.data.res == 1) {
						var index = res.data.file.lastIndexOf("excel");
						var fileName = res.data.file.substring(index + 6, res.data.file.length)
						//window.location.href = this.http.slice(0, -5) + '/zkepA/storage/excel' + fileName
						//window.location.href = 'http://www.380v.top' + '/storage/excel' + fileName
//						let fileUrl = this.http.slice(0, -5) + '/zkepA/storage/excel' + fileName;
						let fileUrl = 'http://www.380v.top' + '/storage/excel' + fileName;
						let fileNameArray = fileUrl.split('/');
						let fileName = fileNameArray[fileNameArray.length - 1];
						let element = document.createElement('a');
						element.style.display = 'none';
						element.setAttribute('href', fileUrl);
						element.setAttribute('download', fileName);
						document.body.appendChild(element);
						element.click();
						document.body.removeChild(element);
						setTimeout(() => {
							this.loadingAdd.close();
							this.$message({
								type: 'success',
								message: '导出成功'
							});
						}, 3000);

					} else {
						this.$message({
							type: 'error',
							message: res.data.msg + '!'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//总条数
			getTotal() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					category_id: this.category_id,
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					category_id: this.category_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//新增抄读方式
			addClick() {
				this.title = "新建抄读方式"
				this.dialogFormVisible = true
			},
			//锁定、解锁
			lockClick(id, lock_status) {
				var confirmValue;
				this.lock_status = lock_status
				var params = {
					id: id,
					lock_status: lock_status
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(lock_status == 1) {
					confirmValue = '确认要锁定吗?'
				} else {
					confirmValue = '确认要解锁吗?'
				}
				this.$confirm(confirmValue, '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/parser/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible = false
							this.getList()
							this.emptyList()
						} else {
							this.$message('操作失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(err => {
					console.log(err)
				})
			},
			//查看
			detailClick(id, list) {
				//				this.$router.push({
				//					path: '/parser/parserDetail',
				//					name: 'ParserDetail',
				//					query: {
				//						id: id,
				//						list: JSON.stringify(list), //解决页面跳转时携带对象参数，在刷新页面时对象不展示的问题：（先把对象转成字符串，再JSON.parse转成对象）
				//					}
				//				})
				this.$router.push({
					path: '/parser/parserDetail',
					name: 'ParserDetail',
					query: {
						id: id,
						fI: this.pageIndex
					}
				})
			},
			//编辑的点击
			editClick(id, list) {
				this.categoryData = []
				this.dialogFormVisible = true
				this.title = '编辑抄读方式'
				this.editId = id;
				this.nameValue = list.name
				this.remark = list.remark
				var str1 = list.category_id.substr(1); //删除首字符
				var str2 = str1.substring(0, str1.length - 1); //删除尾字符
				var arr = str2.split(',')
				arr.forEach(item => {
					this.categoryData.push(Number(item))
				})
				this.categoryData.forEach((el) => {
					el = Number(el)
					this.categoryList.forEach((v) => {
						if(el === v.id) {
							v.isCheck = true
						}
					})
				})
			},
			//取消
			cancleClick() {
				this.dialogFormVisible = false
				this.categoryData = []
				this.categoryList.forEach((v) => {
					v.isCheck = false
				})
			},
			//select多选
			handleWeekChange(val) {
				this.categoryList.forEach((v) => {
					v.isCheck = false
				})
				val.forEach((el) => {
					this.categoryList.forEach((v) => {
						if(el === v.id) {
							v.isCheck = true
						}
					})
				})
			},
			handleCheckBoxWeekChange(val, item) {
				if(val) {
					this.categoryData.push(item.value)
				} else {
					let index = this.categoryData.findIndex((ele) => ele.value === item.value)
					this.categoryData.splice(index)
				}
			},
			//保存
			save() {
				var ids = []
				this.categoryList.forEach(item => {
					if(item.isCheck == true) { //添加
						ids.push(item.id)
					}
				})
				ids = ids.join()
				ids = ',' + ids + ','
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				var manager_id = window.sessionStorage.getItem('id')
				if(this.editId) { //编辑
					var params = {
						id: this.editId,
						name: this.nameValue,
						remark: this.remark,
						status: 1,
						manager_id: manager_id,
						create_time: timestamp,
						category_id: ids
					}
				} else {
					var params = { //添加
						name: this.nameValue,
						remark: this.remark,
						status: 1,
						manager_id: manager_id,
						create_time: timestamp,
						lock_status: 0,
						category_id: ids
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.nameValue) {
					axios.post(this.http + '/zkep2/parser/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible = false
							this.getList()
							this.emptyList()
						} else {
							this.$message('新增失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入必填项！')
				}
			},
			//复制
			copyClick(id, val) {
				this.newName = ''
				this.oldId = id
				this.title = "复制抄读方式：" + val
				this.dialogFormVisible2 = true
			},
			//确认复制保存
			copySave() {
				let config = headers.headers('copyParser')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var manager_id = window.sessionStorage.getItem('id')
				var params = {
					id: this.oldId,
					newName: this.newName,
					manager_id: manager_id
				}
				//console.log(params)
				axios.post(this.http + '/zkep2/parser/copyParser', qs.stringify(params), {
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data == 1) {
						this.dialogFormVisible2 = false
						this.getList();
						this.$message({
							type: 'success',
							message: '复制成功!'
						});
					} else {
						this.$message({
							type: 'error',
							message: '复制失败!'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//删除
			deleteClick(id) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: id,
					status: 0
				}
				//console.log(params)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/parser/save', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getList();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//清空
			emptyList() {
				this.nameValue = ''
				this.remark = ''
				this.editId = ''
			},

		}
	}
</script>

<style>
	.parser {
		height: 100%;
		padding: 4.2% 12% 0 12%;
		position: relative;
	}
	
	.parser .el-table th {
		color: #000;
	}
	
	.parser .el-table {
		font-size: 12px;
	}
	
	.parser .el-table th,
	.parser .el-table td,
	.parser .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.parser .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
	
	.parser .headerBox {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px 6px 0;
		border-radius: 3px;
		font-size: 13px;
		margin-bottom: 10px;
	}
	
	.parser .addButtonClass {
		position: absolute;
		top: 4px;
		right: 10px;
		padding: 10px 12px;
		font-size: 13px;
	}
	
	.parser .addButtonClass2 {
		position: absolute;
		top: 4px;
		right: 124px;
		padding: 10px 12px;
		font-size: 13px;
	}
	
	.parser .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	/*加载图标*/
	
	.el-loading-spinner {
		font-size: 46px;
	}
	
	.el-loading-spinner i {
		color: #34495e!important;
		opacity: 0.7;
	}
	
	.parser .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.parser .el-dialog__title {
		color: #999;
	}
	
	.parser .el-dialog__footer {
		text-align: center;
	}
	
	.parser .pagination {
		text-align: center;
	}
	
	.parser .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	
	.parser .copyDialog .el-dialog__title {
		color: #000;
		font-size: 14px;
	}
	
	.parser .copyDialog .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}
	/*tabs*/
	
	.parser .el-radio-button:first-child .el-radio-button__inner {
		border-radius: 0;
	}
	
	.parser .el-radio-button:last-child .el-radio-button__inner {
		border-radius: 0;
	}
	
	.parser .el-radio-button__inner {
		background-color: #eee;
		padding: 10px 20px;
		min-width: 70px;
		font-size: 13px;
	}
	
	.parser .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: #457ED8;
		border-color: #457ED8;
	}
	/*select*/
	
	.el-select-dropdown.is-multiple .el-select-dropdown__item.selected:after {
		display: none;
	}
	
	.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
		color: #0050E6;
		font-weight: 400;
		background-color: #ECF2FE;
	}
	
	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #0050E6;
		border-color: #0050E6;
	}
</style>


// WEBPACK FOOTER //
// src/components/Parser/Parser.vue